import { query_recuitment_company_list } from '@/api/baseinfo-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import cacheRemoteSelect from '@/components/FormRender/utils';

const org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const search_config: any = {
  model: {
    org_id: org?.id,
    is_active: true,
    page_index: 1,
    pageSize: 2000,
  },
  watch: [],
};

export default (modelType?: string) => {
  return {
    getData: cacheRemoteSelect(query_recuitment_company_list, modelType),
    searchConfig: search_config,
  };
};
